import React from "react";

import MyEnrolmentsCard from "./Enrolment/MyEnrolmentsCard";
import ThisTheme from "../../../themes/MSFTheme";

function TMSWidget() {
    return (
        <React.Fragment>
            <MyEnrolmentsCard theme={ThisTheme} />
        </React.Fragment>
    );
}

export default TMSWidget;
